import React, { useState, useEffect, useContext } from "react";
import { List, ListItem, Box, CircularProgress } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { LegalEntityAvatar, PersonAvatar, Tag } from "../Snippet";
import { Icon } from "../../assets";
import { useDrawer } from "../Drawer";
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { AppContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from "react-json-pretty"

const InfoHeaderContract = ({ view, item }) => {
    const { t } = useTranslation();
    const { activate } = useDrawer();
    const { formatDistance, formatDate, formatCurrencyVariable } = useFormatter();
    const { appConfiguration } = useContext(AppContext);

    const [endAt, setEndAt] = useState();
    useEffect(() => {
        if (!item) return;
        if (item?.end_at) {
            const endAt = new Date(item.end_at)
            setEndAt(endAt)
        } else if (item.start_at && item.contractDuration) {
            const endAt = new Date(item.start_at);
            endAt.setMonth(endAt.getMonth() + parseInt(item.contractDuration));
            endAt.setDate(endAt.getDate() - 1);

            setEndAt(endAt);
        }
    }, [item])

    return (
        <Box className={"info-header info-header-" + view}>
            <Box className={"info-wrapper"}>
                <>
                    <Box className="info-summary-external">
                        {
                            item?.legalEntity ? <LegalEntityAvatar name={item?.legalEntity?.name} url={item?.legalEntity?.logo?.url} withname={true} /> : <CircularProgress size="sm" />
                        }
                        {appConfiguration.dashboard.view == 'ConsecutionSales' && (

                            <PersonAvatar
                                item={item?.account?.person}
                                firstname={item?.account?.person?.firstname || item?.account?.person?.name}
                                lastname={item?.account?.person?.lastname}
                                size="small"
                                url={item?.account?.person?.picture?.url}
                                withname={true}
                            />
                        )}
                    </Box>
                    <Box className="info-name">
                        {appConfiguration.dashboard.view != 'ConsecutionSales' && (
                            <span class="primary">{item?.contractIdentifier}</span>
                        )}
                        {appConfiguration.dashboard.view == 'ConsecutionSales' && (
                            <span class="primary">{item?.IDPartner}</span>
                        )}
                        <span class="secondary">{formatCurrencyVariable(item?.totalLeaseFee, 'EUR')}</span>
                    </Box>
                    <List className="info-details">
                        <ListItem>
                            <span className="key">{t('renter')}</span>

                            <span className="value">
                                {!item?.renter ? (
                                    <CircularProgress size="sm" />
                                ) : !item?.renter?.name ? (
                                    <Tag color={"warning"} title={t("No renter defined")}>
                                        <Icon icon="faWarning" />
                                        {t('No renter defined')}
                                    </Tag>
                                ) : (
                                    <Box className="info-summary-external">
                                        <LegalEntityAvatar
                                            name={item.renter.name}
                                            url={item.renter.logo?.url}
                                            size="small"
                                            withname={true}
                                            style={{ height: '23px' }}
                                        />
                                    </Box>
                                )}
                            </span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('contractMileage')}</span>
                            <span className="value">{item?.contractMileage ? formatDistance(item?.contractMileage) : (<Tag color={"warning"} title={t("No mileage defined")}><Icon icon="faWarning" />{t('No mileage defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('contractDuration')}</span>
                            <span className="value">{item?.contractDuration ? item?.contractDuration + t('months') : (<Tag color={"warning"} title={t("No duration defined")}><Icon icon="faWarning" />{t('No duration defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('start_at')}</span>
                            <span className="value">{item?.start_at ? formatDate(item?.start_at) : (<Tag color={"warning"} title={t("No start_at defined")}><Icon icon="faWarning" />{t('No start_at defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('end_at')}</span>
                            <span className="value">{endAt ? formatDate(endAt) : (<Tag color={"warning"} title={t("No end_at defined")}><Icon icon="faWarning" />{t('No end_at defined')}</Tag>)}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('vehicle status')}</span>
                            <Box className="value">
                                <span className="value">
                                    {!item?.car ? (
                                        <CircularProgress size="sm" />
                                    ) : !item?.car?.status ? (
                                        <Tag color={"danger"} title={t("Missing vehicle status")}><Icon icon="faWarning" />{t('Missing')}</Tag>
                                    ) : (
                                        <Tag color={"secondary"} size="small" label={t(item?.car?.status)} />
                                    )}
                                </span>
                            </Box>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('has_reajusted')}</span>
                            <span className="value">{item?.parentContract ? <Icon icon="faCircleCheck" family='fas' style={{ color: 'rgb(73, 153, 73)', marginTop: '4px' }} /> : <Icon icon="faCircleXmark" family='fas' style={{ color: '#FF0000', marginTop: '4px' }} />}</span>
                        </ListItem>
                        <ListItem>
                            <span className="key">{t('is_reajusted')}</span>
                            <span className="value">{item?.childContract ? <Icon icon="faCircleCheck" family='fas' style={{ color: 'rgb(73, 153, 73)', marginTop: '4px' }} /> : <Icon icon="faCircleXmark" family='fas' style={{ color: '#FF0000', marginTop: '4px' }} />}</span>
                        </ListItem>
                    </List>
                </>
            </Box>

        </Box>
    )
}

export default InfoHeaderContract;